import { Component } from '@theme/component';
import { ResizeNotifier } from '@theme/utilities';

class ProductDescriptionTabsCarousel extends Component {
  requiredRefs = ['track'];

  connectedCallback() {
    super.connectedCallback();

    // @ts-ignore
    this.refs.track?.addEventListener('scroll', this.#handleScroll, { passive: true });
  }

  disconnectedCallback() {
    // @ts-ignore
    this.refs.track?.removeEventListener('scroll', this.#handleScroll);
  }

  #handleScroll = () => {
    if (this.#scheduled) return;
    this.#scheduled = true;
    requestAnimationFrame(() => {
      this.#scheduled = false;
    });
  };

  #scheduled = false;

  get #direction() {
    return getComputedStyle(this).direction === 'rtl' ? -1 : 1;
  }

  // @ts-ignore
  #scrollByPage(sign) {
    const { track } = this.refs;
    if (!track) return;
    // @ts-ignore
    track.scrollBy({ left: sign * this.#direction * (track.clientWidth * 0.9), behavior: 'smooth' });
  }

  scrollPrevious = () => this.#scrollByPage(-1);
  scrollNext = () => this.#scrollByPage(1);
}

if (!customElements.get('product-description-tabs-carousel')) {
  customElements.define('product-description-tabs-carousel', ProductDescriptionTabsCarousel);
}